import React from 'react';
import { MyAnalyticsDimensionType } from 'graphql/types';
import { useGetMyAnalyticsData } from 'modules/Insights/Notes/hooks/useGetMyAnalyticsData';
import { transformAnalyticsData } from './utils';
import { SummarySkeleton } from './SummarySkeleton';
import { SummaryComponent } from './SummaryComponent';
import { NoDataSummaryChart } from './NoDataSummaryChart';

export const UserHoursSummaryChart: React.FC = () => {
  const { data, loading, isEmpty } = useGetMyAnalyticsData(
    MyAnalyticsDimensionType.MetricsByHoursSummary
  );

  const tranformData = transformAnalyticsData(data?.myAnalytics?.items);

  return (
    <>
      {loading ? (
        <SummarySkeleton />
      ) : isEmpty ? (
        <NoDataSummaryChart />
      ) : (
        <SummaryComponent tranformData={tranformData} />
      )}
    </>
  );
};
